import React from 'react'
import Breadcrub from '../Common/Breadcrub'

const FeeStructure = () => {
  return (
    <>
      <Breadcrub title="Fee Structure"  />
        <section class="aboutus-style-01">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xl-12">
                        <div class="row g-0 event-wrapper">                           
                            <div class="col-md-12">
                                <div class="p-1-3 p-sm-1-9">
                                    <p>Fee Structure is available at the reception of the institute.</p>
                                    <p>The Institute fee & Hostel fee can also made by NEFT/RTGS.</p>                             
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default FeeStructure
